export {
  handleLinkClickFunction,
  getAppLinkHandler,
  removeHashFromUrl,
} from './linkHelperFunctions';
